// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3_yXC","name":"Header_name__3pkby","birthday":"Header_birthday__Lem7C","skeleton":"Header_skeleton__1ucRQ"};